import { Table } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { getVdsOfUser, getOwnVdsOfUser } from 'services/users';
import Panel from './Panel';

function OwnDesktops({ title, bodyStyle, user, contents, readOnly, onSelect, id, apprType }) {
  const [dataSource, setDataSource] = useState([]);
  const [defaultSelectKey, setDefaultSelectKey] = useState([]);
  useEffect(() => {
    if (!user) {
      setDataSource([]);
      return;
    }

    if (apprType === 'approval.types.create-vd') {
      getOwnVdsOfUser(user).then((data) => {
        let source = data?.data;

        if (readOnly && contents) {
          source = contents;
        }

        const keys = [];
        if (contents) {
          contents.forEach((v) =>
            source.map((d) => {
              if (v.id === d.id) {
                keys.push(v.id);
              }
              return null;
            }),
          );
        }
        setDataSource(source || []);
        setDefaultSelectKey(keys);
        if (contents) {
          onSelect(contents);
        }
      });
    } else {
      getVdsOfUser(user, id).then((data) => {
        let source = data?.data;

        if (readOnly && contents) {
          source = contents;
        }

        const keys = [];
        if (contents) {
          contents.forEach((v) =>
            source.map((d) => {
              if (v.id === d.id) {
                keys.push(v.id);
              }
              return null;
            }),
          );
        }
        setDataSource(source || []);
        setDefaultSelectKey(keys);
        if (contents) {
          onSelect(contents);
        }
      });
    }
  }, [user]);

  return (
    <Panel title={title} bodyStyle={bodyStyle}>
      <Table
        size="small"
        rowKey="id"
        pagination={false}
        dataSource={dataSource}
        columns={[
          {
            title: 'Desktop 그룹( VM )',
            dataIndex: 'vdGroupName',
            render: (text, record) => `${text}( ${record.vdName} )`,
          },
          {
            title: 'OS',
            dataIndex: 'os',
          },
          {
            title: 'CPU',
            dataIndex: 'cpu',
            align: 'right',
          },
          {
            title: 'Memory',
            dataIndex: 'memory',
            align: 'right',
          },
          {
            title: 'Disk',
            dataIndex: 'disk',
            align: 'right',
          },
          {
            title: '생성 일시',
            dataIndex: 'createDate',
            render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
          },
        ]}
        rowSelection={
          readOnly
            ? false
            : {
                type: 'checkbox',

                selectedRowKeys: defaultSelectKey,
                onChange: (key, record) => {
                  setDefaultSelectKey(key);
                  onSelect(record);
                },
              }
        }
      />
    </Panel>
  );
}

export default OwnDesktops;
